export default __webpack_public_path__ + "static/media/templateExpand.051ac20c.svg";